import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {DialogService} from '@shared/services/dialog-service';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';

/**
 * "Create Visualization" in a folder's Premium Features menu, and as a plain folder action for
 * EXPERT-DASHBOARD companies (XCT-E-18-01).
 *
 * The same two-step the Xact script create uses: ask for the name here, then re-dispatch the backend's own
 * command with it. The server owns everything after that - the canvas, the stub .viz entry and the link
 * between them - and answers with a RedirectCommand into the Designer, so this handler knows nothing about them.
 */
@Injectable({
  providedIn: 'root',
})
export class CreateVisualizationCommandHandler implements IPlatformCommandHandler {
  constructor(
    private dialogService: DialogService
  ) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    this.dialogService.showTextInputDialog('Visualization Name', '')
      .pipe(take(1))
      .subscribe(state => {
        if (state.action === 'OK') {
          // Title, because that is the field CreateVisualizationCommandConsumer reads the name from.
          command.fieldValues['Title'] = state.data.input.text;
          handler.executeCommand(command);
        }
      });
    return true;
  }
}
